import { Glue42Core } from "@glue42/core";

import {Glue42Office} from "../../../glue4office";
import {TaskImpl} from "../items/TaskImplementation";
import {EmailImpl} from "../items/EmailImplementation";
import {AttachmentImpl} from "../items/AttachmentImplementation";

export const itemFromJSON = (
    item: Glue42Office.Outlook.T42Email | Glue42Office.Outlook.T42Task | Glue42Office.Outlook.T42Attachment,
    agm: Glue42Core.AGM.API,
    itemType: string): any => {
    if (!item) {
        throw new Error(`${itemType} is mandatory`);
    }

    if (!item.ids) {
        throw new Error(`${itemType} ids property is mandatory`);
    }

    if (itemType === "email") {
        return new EmailImpl((item as Glue42Office.Outlook.T42Email), agm);
    } else if (itemType === "task") {
        return new TaskImpl((item as Glue42Office.Outlook.T42Task), agm);
    } else {
        return new AttachmentImpl((item as Glue42Office.Outlook.T42Attachment), agm);
    }
};
